export const lastOrDefault = (source, predicate) => {
    if (predicate) {
        return lastOrDefault2(source, predicate);
    }
    else {
        return lastOrDefault1(source);
    }
};
const lastOrDefault1 = async (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            if (values.length === 0) {
                return null;
            }
            else {
                return values[values.length - 1];
            }
        }
        case 1: {
            const promises = dataFunc.generator();
            if (promises.length === 0) {
                return null;
            }
            else {
                return await promises[promises.length - 1];
            }
        }
        case 2: {
            const promises = await dataFunc.generator();
            if (promises.length === 0) {
                return null;
            }
            else {
                return await promises[promises.length - 1];
            }
        }
    }
};
const lastOrDefault2 = async (source, predicate) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            for (let i = values.length - 1; i >= 0; i--) {
                const value = values[i];
                if (predicate(value)) {
                    return value;
                }
            }
            break;
        }
        case 1: {
            const promises = dataFunc.generator();
            for (let i = promises.length - 1; i >= 0; i--) {
                const value = await promises[i];
                if (predicate(value)) {
                    return value;
                }
            }
            break;
        }
        case 2: {
            const promises = await dataFunc.generator();
            for (let i = promises.length - 1; i >= 0; i--) {
                const value = await promises[i];
                if (predicate(value)) {
                    return value;
                }
            }
            break;
        }
    }
    return null;
};
